import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { Namespace } from './NamespacePicker';

export const NamespacePickerExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'NamespacePicker',
        component: Namespace,
    }),
);
